import { render, staticRenderFns } from "./SVGLoader.vue?vue&type=template&id=9c070ee8&"
import script from "./SVGLoader.vue?vue&type=script&lang=js&"
export * from "./SVGLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports